'use strict';

var React = require('react');

var SvgBlogMajor = function SvgBlogMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.746 3.104a.5.5 0 0 0 0-.707l-1.06-1.061a.5.5 0 0 0-.707 0l-.957.957 1.767 1.768.957-.957Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.082 4.768-1.768-1.768-3.699 3.7a2 2 0 0 0-.585 1.406l-.003.698a.25.25 0 0 0 .251.251l.698-.002a2 2 0 0 0 1.407-.586l3.7-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4.75c0-.69.56-1.25 1.25-1.25h3.25a.75.75 0 0 0 0-1.5h-3.25a2.75 2.75 0 0 0-2.75 2.75v10.5a2.75 2.75 0 0 0 2.75 2.75h6.5a2.75 2.75 0 0 0 2.75-2.75v-7.25a.75.75 0 0 0-1.5 0v7.25c0 .69-.56 1.25-1.25 1.25h-6.5c-.69 0-1.25-.56-1.25-1.25v-10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 10.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 14.25a.75.75 0 0 1 .75-.75h2.75a.75.75 0 0 1 0 1.5h-2.75a.75.75 0 0 1-.75-.75Z"
  }));
};
SvgBlogMajor.displayName = "BlogMajor";

exports.SvgBlogMajor = SvgBlogMajor;
